<template>
    <div class="container-fluid">
        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row mb-3 px-3 align-items-center">
                        <div>
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <label class="switch">
                            <input type="checkbox" v-model="filter.switch1" @change="changeState(1)">
                            <span class="slider text-black-50">Бажарилган иш хажми</span>
                        </label>

                        <label class="switch">
                            <input type="checkbox" v-model="filter.switch2">
                            <span class="slider text-black-50">Умумий маълумотлар</span>
                        </label>

                        <label class="switch">
                            <input type="checkbox" v-model="filter.switch3"  @change="changeState(3)">
                            <span class="slider text-black-50">Харажатлар</span>
                        </label>

                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-xl-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-xl-2 col-md-3 col-sm-6 mb-2">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label>{{$t("realEstate.field.evaluator")}}</label>
                                <v-select v-model="filter.employee" label="name"
                                          :options="employes"
                                          :filterable="false"
                                          @search:focus="onEmployeReportFocus">
                                    <template slot="option" slot-scope="option" v-if="option && option.name">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <template slot="selected-option"
                                              v-if="filter && filter.employee && filter.employee.name">
                                        <div v-html="filter.employee.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-xl-3 col-lg-4 col-md-6 mb-2">
                                <label>{{$t("accounting.account.province")}}</label>
                                <select class="form-control" v-model="filter.province">
                                    <option value=""></option>
                                    <option :value="option" v-for="option in provinces" :key="option.id">
                                        {{option.name}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-1 align-self-end">
                                <label style="align-self: center">{{$t("main.search")}}</label>
                                <button class="all-btn m-0 mb-2 form-control" @click="searchByFilter"
                                        style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                                    <i class="fa fa-filter"></i>
                                </button>
                            </div>
                        </div>

                        <div v-if="filter.switch1" class="row">
                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch11"
                                       v-model="filter.switch11">
                                <label class="custom-control-label" for="customSwitch11">МИБ</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch12"
                                       v-model="filter.switch12">
                                <label class="custom-control-label" for="customSwitch12">Божхона</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch13"
                                       v-model="filter.switch13">
                                <label class="custom-control-label" for="customSwitch13">ДТП</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch14"
                                       v-model="filter.switch14">
                                <label class="custom-control-label" for="customSwitch14">Автомототранспорт</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch15"
                                       v-model="filter.switch15">
                                <label class="custom-control-label" for="customSwitch15">Кучмас мулк</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch16"
                                       v-model="filter.switch16">
                                <label class="custom-control-label" for="customSwitch16">Бошка мол мулклар</label>
                            </div>

                        </div>

                        <div v-if="filter.switch3" class="row">
                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch31"
                                       v-model="filter.switch31">
                                <label class="custom-control-label" for="customSwitch31">ЯТТларга ўтказиладиган
                                    маблағ</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch32"
                                       v-model="filter.switch32">
                                <label class="custom-control-label" for="customSwitch32">Солик</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch33"
                                       v-model="filter.switch33">
                                <label class="custom-control-label" for="customSwitch33">Вазнаграждениялар</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch34"
                                       v-model="filter.switch34">
                                <label class="custom-control-label" for="customSwitch34">Иш хакки харажати</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch35"
                                       v-model="filter.switch35">
                                <label class="custom-control-label" for="customSwitch35">Проче расход</label>
                            </div>

                            <div class="custom-control custom-switch" style="margin-left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="customSwitch36"
                                       v-model="filter.switch36">
                                <label class="custom-control-label" for="customSwitch36">Жами харажат</label>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="ml-2" v-if="loading">
                            <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                            {{$t("asset.esp.contractDownload")}}
                        </div>
                        <div class="col col-12">
                            <iframe id="invoiceFrame" frameborder="0" width="1550px" height="650px"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    import Datepicker from 'vuejs-datepicker';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate, format_date} from '@/shared/utils';

    export default {
        name: "ReportOfWorkDoneiFrame",
        components: {
            Datepicker
        },

        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                show: false,
                province: {},
                provinces: [],
                employes: [],
            }
        },
        methods: {
            searchByFilter() {
                this.filter.page.page = 1;
                this.initList();
            },
            changeState(val) {
                console.log(val);
                if (val == 1 && this.filter.switch1 == false) {
                    this.filter.switch11 = this.filter.switch1; // МИБ
                    this.filter.switch12 = this.filter.switch1; // Божхона
                    this.filter.switch13 = this.filter.switch1; // ДТП
                    this.filter.switch14 = this.filter.switch1; // Автомототранспорт
                    this.filter.switch15 = this.filter.switch1; // Кучмас мулк
                    this.filter.switch16 = this.filter.switch1; // Бошка мол мулклар
                } else if (val == 3 && this.filter.switch3 == false) {
                    this.filter.switch31 = this.filter.switch3; // ЯТТларга ўтказиладиган
                    this.filter.switch32 = this.filter.switch3; // Солик
                    this.filter.switch33 = this.filter.switch3; // Вазнаграждениялар
                    this.filter.switch34 = this.filter.switch3; // Иш хакки харажати
                    this.filter.switch35 = this.filter.switch3; // Проче расход
                    this.filter.switch36 = this.filter.switch3; // Жами харажат

                }
            },

            initList() {
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.loading = true;
                this.init();
                console.log(this.filter);
                if (this.filter.startDate && this.filter.endDate) {
                    this.$http.post('/report/work/done/list', this.filter).then(response => {
                        let blob = new Blob([response.data], {type: 'text/html'});
                        let encodedString = URL.createObjectURL(blob);
                        let iFrame = document.getElementById("invoiceFrame");
                        iFrame.src = encodedString;
                        this.loading = false;
                    }).catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
                } else {
                    this.loading = false;
                }
            },
            format_date(value) {
                if (value) {
                    return format_date(value)
                }
                return null;
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },

            onEmployeReportFocus() {
                this.employes = [];
                this.filter.search = '';
                this.$http.post('/user/admins', this.filter)
                    .then(res => {
                        this.employes = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }


        },
        created() {
            this.$eventBus.$on('ReportOfWorkDone', (data) => {
                console.log(data);
                this.initList();
            });
            this.initList();
        }
    }
</script>

<style scoped>
    .switch {
        position: relative;
        display: inline-block;
        width: 180px;
        height: 25px;
        margin: 5px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
        text-align: center;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 10px;
        width: 20px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(160px);
        -ms-transform: translateX(155px);
        transform: translateX(155px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 25px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>
